var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnect = function SvgConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0,
    transform: "rotate(-45)",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 10a1 1 0 0 0-1-1h-.5a5.5 5.5 0 1 0 0 11h5a5.5 5.5 0 0 0 1.573-10.772c-.563-.168-1.073.3-1.073.889v.051c0 .498.375.906.834 1.095A3.501 3.501 0 0 1 17.5 18h-5a3.5 3.5 0 1 1 0-7h.5a1 1 0 0 0 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4a5.5 5.5 0 1 1 0 11H11a1 1 0 1 1 0-2h.5a3.5 3.5 0 1 0 0-7h-5a3.5 3.5 0 0 0-1.334 6.737c.46.19.834.597.834 1.095v.051c0 .588-.51 1.057-1.073.889A5.5 5.5 0 0 1 6.5 4z"
  }))));
};
export default SvgConnect;